import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import RedirectModal from "./RedirectModal";
import { generateLoginUrl } from "../../utlities/auth.utility";

const LoginModalContext = createContext({
  openLoginModal: () => {},
  closeLoginModal: () => {},
  isLoginModalOpen: false,
});

export function LoginModalProvider({ children }) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const openLoginModal = useCallback(() => {
    setIsLoginModalOpen(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setIsLoginModalOpen(false);
  }, []);

  const handleLoginModalStateChanged = useCallback((nextState) => {
    if (typeof nextState === "boolean") {
      setIsLoginModalOpen(nextState);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      openLoginModal,
      closeLoginModal,
      isLoginModalOpen,
    }),
    [openLoginModal, closeLoginModal, isLoginModalOpen]
  );

  return (
    <LoginModalContext.Provider value={contextValue}>
      {children}
      <RedirectModal
        modalId="login-modal"
        isOpen={isLoginModalOpen}
        onRequestClose={closeLoginModal}
        onStateChanged={handleLoginModalStateChanged}
        redirectURL={generateLoginUrl()}
        redirectTitle="ACR Repository Login"
        redirectBody="You are about to navigate to Login.gov to Login. After, you will be directed back to the ACR Repository."
        redirectButtonText="Login"
      />
    </LoginModalContext.Provider>
  );
}

LoginModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useLoginModal() {
  return useContext(LoginModalContext);
}
